import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Swatches from '../Swatches';

const Container = styled.div``;

const Note = styled.div`
  text-transform: none;
  color: #000;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 0.9em;
  font-weight: normal;
  margin-top: 20px;
`;

export default class FrameFinish extends PureComponent {
  reorderOptions = options => {
    let noneOption = null;
    const newOptions = options.filter((item, idx) => {
      if (
        typeof item.id === 'string' &&
        item.id.toLocaleLowerCase() === 'none'
      ) {
        noneOption = item;
        return false;
      }
      return true;
    });
    if (noneOption) {
      newOptions.unshift(noneOption);
    }
    return newOptions;
  };
  render() {
    const { currentSelection, setCurrentSelection, images } = this.props;
    const activeBase = currentSelection['FrameFinish'];
    const activePremium = currentSelection['PremiumOptions'];
    if (!images) return null;
    const premiumImages = this.reorderOptions(images.premium);
    return (
      <Container>
        <Swatches
          selectKey="FrameFinish"
          onClick={setCurrentSelection}
          active={activeBase}
          col={4}
          images={images.base}
        />
        <Note> Premium options for arms and base. </Note>
        <Swatches
          selectKey="PremiumOptions"
          onClick={setCurrentSelection}
          active={activePremium}
          col={4}
          images={premiumImages}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accords/FrameFinish.js